export const formattedServiceNames = {
  xracademy: 'XR Academy',
  funbox: 'Funbox',
  entertainu: 'EntertainU',
  movio: 'Movio'
};

export const prices = {
  trialPrice: '0,01',
  subscriptionPrice: '49,99'
};

export const portfolioUrl = {
  xracademy: 'https://xracademy-gap.com',
  funbox: '',
  entertainu: '',
  movio: ''
};

export const serviceLinks = {
  privacyLink: '/{locale}/privacy-policies/',
  refundLink: '/{locale}/unsubscribe-refund/',
  termsLink: '/{locale}/terms/',
  faqLink: '{locale}/unsubscribe-refund/#faq',
  aboutLink: '/{locale}/about/',
  contactLink: '/{locale}/contact/'
};
